/**
 * ProjectSelectorInput is a component used to select multiple projects (project portfolio).
 *
 *
 * @example
 *
 *  MyComponent = () => {
 *   const [selectedProjects, setSelectedProjects] = useState([]);
 *
 *   // handle onChange event of the ProjectSelectorInput
 *     const handleOnChangeSelectorInput = (data) => {
 *       setSelectedProjects(data);
 *     }
 *
 *    return (
 *      <ProjectSelectorInput
 *         name="monitoring_report[project_ids][]"
 *         handleOnChangeSelectorInput={handleOnChangeSelectorInput}
 *         defaultValues={[{ label: 'test', value: 1 }]} />
 *      )
 *  }
 */

import React, {useState} from 'react';
import Select from 'react-select';
import { FaIcon } from './Icons.jsx'
import ProjectSelectorModal from './ProjectSelectorComponent/ProjectSelectorModal.jsx';

function ProjectSelectorInput({name, handleOnChangeSelectorInput, defaultValues = []}) {
    const [data, setData] = useState(defaultValues);
    const [openModal, setOpenModal] = useState(false);

    // handle onClose event of the modal
    const handleOpenModal = () => setOpenModal(!openModal);

    // handle onSave event of the modal
    const handleSaveModal = (data) => {
        setData(data);
        handleOnChangeSelectorInput(data);
    }

    // handle onChange event of the dropdown
    const handleChange = (e) => {
        let newData = Array.isArray(e) ? e : [];
        setData(newData);
        handleOnChangeSelectorInput(newData);
    }

    // handle onClick event of the dropdown
    const handleClick = (e) => {
        handleOpenModal(true);
    }

    return (<>
        <Select
            name={name}
            className="dropdown"
            placeholder="Select Option"
            value={data} // set selected values
            options={data} // set list of the data
            onChange={handleChange} // assign onChange function
            isMulti
            isClearable
            onMenuOpen={handleClick}
            components={{
                DropdownIndicator: () => <FaIcon type="list" style={{margin: "auto 15px", cursor: "pointer"}} />,
                indicatorSeparator: () => ({margin: "10px"})
            }
            }/>

        {openModal && <ProjectSelectorModal {...{ handleOpenModal, handleSaveModal }} selectedItems={data}></ProjectSelectorModal>}
    </>);
}

export default ProjectSelectorInput;
